module.exports = __webpack_public_path__ + "img/all-zones-inactive.ec7e84c4.svg";